import script from "./StepNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./StepNavigation.vue?vue&type=style&index=0&id=3e17eb46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e17eb46"]])

export default __exports__